// eslint-disable-next-line jira/filename-case
import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { ItamSettingsSkeleton } from './skeleton/ItamSettingsSkeleton.tsx';

/**
 * Lazy sidebar components per practice.
 * Each practice gets its own webpack chunk for code-splitting.
 * When SAM/CAM are ready, add their lazy sidebar here.
 */
const LazyHamSidebar = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-itam-nav4-settings-sidebar-ham" */ '@jira/itam__ham-settings/src/HamSettingsSideNavMain.tsx'
		),
	{
		entryFsSsrLiftImportToModule: true,
	},
);
// const LazySamSidebar = lazyForPaint(() => import(...));
// const LazyCamSidebar = lazyForPaint(() => import(...));

/**
 * Practice-to-sidebar mapping.
 * Defaults to HAM when the practice param is missing or unrecognised.
 */
const PRACTICE_SIDEBARS: Record<string, React.ComponentType> = {
	ham: LazyHamSidebar,
	// sam: LazySamSidebar,
	// cam: LazyCamSidebar,
};

const DEFAULT_SIDEBAR = LazyHamSidebar;

const useRouteParams = createRouterSelector(({ match }) => match.params);

const SidebarRouter = (): React.JSX.Element => {
	const params = useRouteParams();
	const practice = params?.practice || '';
	const SidebarContent = PRACTICE_SIDEBARS[practice] ?? DEFAULT_SIDEBAR;

	return <SidebarContent />;
};

const asyncItamSettingsSidebar = (): React.JSX.Element => (
	<SidebarBoundary
		id="nav4.sidebar.itam-settings"
		packageName="jiraNavigationAppsSidebarNav4ItamSettings"
		ufoName="nav4.sidebar.itam-settings"
	>
		<Placeholder name="nav4.sidebar.itam-settings" fallback={<ItamSettingsSkeleton />}>
			<SidebarRouter />
		</Placeholder>
	</SidebarBoundary>
);

const AsyncItamSettingsSidebar: React.MemoExoticComponent<() => React.JSX.Element> =
	memo(asyncItamSettingsSidebar);
// eslint-disable-next-line jira/filename-case
export default AsyncItamSettingsSidebar;
